import { Box, Grid, Typography, useTheme } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';

export const AddressDetails = () => {
    const theme = useTheme();
    const address = [
        'New Payment Innovation Limited',
        '3010 Lake Drive',
        'Citywest',
        'Dublin',
        'D24 R98P',
    ];

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Box
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: theme.palette.common.white,
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '24px',
                        height: '100%',
                    }}
                >
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        Invoice Address
                    </Typography>
                    {address.map((line, index) => {
                        return (
                            <Typography key={index} variant="body2" gutterBottom>
                                {line}
                            </Typography>
                        );
                    })}
                </Box>
            </Grid>

            <Grid item xs={12} md={6}>
                <Box
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: theme.palette.common.white,
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '24px',
                        height: '100%',
                    }}
                >
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        Delivery Address
                    </Typography>
                    {address.map((line, index) => {
                        return (
                            <Typography key={index} variant="body2" gutterBottom>
                                {line}
                            </Typography>
                        );
                    })}
                </Box>
            </Grid>
        </Grid>
    );
};
